/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2fa_EnabledInputs */

const cs_settings_profile_2fa_enabled = /** @type {(inputs: Settings_Profile_2fa_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapnuto`)
};

const en_settings_profile_2fa_enabled = /** @type {(inputs: Settings_Profile_2fa_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enabled`)
};

/**
* | output |
* | --- |
* | "Enabled" |
*
* @param {Settings_Profile_2fa_EnabledInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa_enabled = /** @type {((inputs?: Settings_Profile_2fa_EnabledInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2fa_EnabledInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa_enabled(inputs)
	return cs_settings_profile_2fa_enabled(inputs)
});